import * as React from 'react';

export default function Mastermind() {
    return (
    <div>MASTERMIND</div>
    );
}

